import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetDevicesVm } from './get-devices.vm';

export const getDevices = async (offset: string, warehouseId: string, term: string, callback: CallbackObject<GetDevicesVm>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
            ...(warehouseId && { warehouseId }),
            ...(term && { term }),
        }
    };

    try {
        const res: AxiosResponse = await instance.get(`/management/devices`, config);
        callback.success(plainToClass(GetDevicesVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
